__turbopack_context__.v({
  "cards": "_8UlpMG_cards",
  "content": "_8UlpMG_content",
  "headContact": "_8UlpMG_headContact",
  "left1": "_8UlpMG_left1",
  "left2": "_8UlpMG_left2",
  "lottieWrapper": "_8UlpMG_lottieWrapper",
  "netralcolor": "_8UlpMG_netralcolor",
  "overlayImage": "_8UlpMG_overlayImage",
  "p": "_8UlpMG_p",
  "page-body-wrap": "_8UlpMG_page-body-wrap",
  "pagehero": "_8UlpMG_pagehero",
  "paragraph": "_8UlpMG_paragraph",
  "paragraph-content": "_8UlpMG_paragraph-content",
  "paragraph2": "_8UlpMG_paragraph2",
  "paragraph3": "_8UlpMG_paragraph3",
  "phonecontent": "_8UlpMG_phonecontent",
  "right1": "_8UlpMG_right1",
  "right2": "_8UlpMG_right2",
  "store": "_8UlpMG_store",
  "t": "_8UlpMG_t",
  "title": "_8UlpMG_title",
  "title2": "_8UlpMG_title2",
  "title3": "_8UlpMG_title3",
  "wrap-container": "_8UlpMG_wrap-container",
  "wrap-content": "_8UlpMG_wrap-content",
});
